<template>
  <div>
    <div class="row" v-if="[3].includes(this.logged_in_user.group_id)">
      <div class="col-4">
          <label for="ddlMachineType">Machine Type</label>
          <select class="form-control" id="ddlMachineType" v-model="machine_type" disabled>
            <option value="Box">Box</option>
            <option value="Cloud">Cloud</option>
          </select>
      </div>
    </div>
    <br>
    <div class="row">
      <div class="col-12">
        <table class="table table-striped">
          <thead class="bg-hub-primary text-white">
          <tr>
            <th>Name</th>
            <th>Status</th>
            <th>Manage</th>
          </tr>
          </thead>
          <tbody>
          <tr v-for="service in filtered_services" :key="service.id">
            <td>{{ service.name }}</td>
            <td>
              <span v-if="service.status === 1"><i class="fa fa-check-circle online"
                                                                   aria-hidden="true"></i> Online</span>
              <span v-else><i class="fa fa-times-circle offline"
                              aria-hidden="true"></i> Offline</span>
            </td>
            <td v-if="service.id !== 5">
              <a href="#" class="btn btn-light" @click="restartService(service)"><i class="fa fa-sync fa-fw" aria-hidden="true"></i> Restart</a>
            </td>
            <td v-if="service.id === 5">
              <a href="#" class="btn btn-light" v-if="service.status !== 1" @click="toggleNTPServer('on')">Enable</a>
            </td>
          </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'

export default {
  name: 'adminDashboard',
  computed: {
    ...mapGetters({
      services: 'allServices',
      phoenix_setting: 'singlePhoenixSetting',
      logged_in_user: 'loggedInUser',
      machine_type: 'machineType'
    }),
    filtered_services: function () {
      return this.services.filter(service => (this.machine_type === 'Box') || (this.machine_type === 'Cloud' && service.id !== 4))
    }
  },
  created () {
    this.$store.dispatch('setDisabledChangeScopedSite', false)
    this.$store.dispatch('getServices')
    this.$store.dispatch('getPhoenixSetting', { domain: 'MACHINE', setting: 'TYPE' })
  },
  methods: {
    ...mapActions([
      'editPhoenixSetting',
      'restartService',
      'toggleNTPServer'
    ]),
    serviceStatus () {
      this.$store.dispatch('getServices')
    }
  },
  mounted () {
    this.interval = setInterval(this.serviceStatus, 1000)
  }
}
</script>

<style scoped>
  .online {
    color: green;
  }

  .offline {
    color: red;
  }
</style>
